import { ErrorModal } from "@dexteel/mesf-core";
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	makeStyles,
} from "@material-ui/core";
import { ChangeEvent } from "react";

const useStyles = makeStyles((theme) => ({
	select: {
		"& .MuiSelect-select": {
			padding: "10px",
			display: "flex",
			alignItems: "center",
		},
	},
}));

export interface Option {
	value: any;
	label: string;
}

interface SelectorFieldDEProps {
	label: string;
	options: Option[];
	value: any;
	onChange: (value: any) => void;
	onBlur?: () => void;
	onFocus?: () => void;
	nullable?: boolean;
	disabled?: boolean;
}

export const SelectorFieldDE = ({
	label,
	options,
	value,
	onChange,
	onBlur,
	onFocus,
	nullable = false,
	disabled = false,
}: SelectorFieldDEProps) => {
	const classes = useStyles();

	const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
		const selectedValue = event.target.value;
		onChange(selectedValue);
	};

	return (
		<>
			<FormControl variant="outlined" fullWidth>
				<InputLabel id={`${label}-selector`}>{label}</InputLabel>
				<Select
					fullWidth
					disabled={disabled}
					labelId={`${label}-selector`}
					id={`${label}-selector`}
					value={value || ""}
					onChange={handleChange}
					label={label}
					inputProps={{ style: { padding: "10px" } }}
					className={classes.select}
					onBlur={onBlur}
					onFocus={onFocus}
				>
					{nullable && (
						<MenuItem key={`${label}-null`} value="">
							None
						</MenuItem>
					)}
					{options.map((option) => (
						<MenuItem key={`${label}-${option.label}`} value={option.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<ErrorModal error={""} onHide={() => {}} />
		</>
	);
};
